/**
 * @file
 * This element copies the innerHTML of the host (Light DOM)
 * to the innerHTML of the element (Shadow DOM) returned by
 * contentElement() (which must use the lwc:dom="manual" directive).
 */
import { LightningElement } from "lwc";

export class ReflectedElement extends LightningElement {
  private observer!: MutationObserver;
  private didSetContent = false;

  get contentElement(): Element {
    throw new Error("Not Implemented");
  }

  connectedCallback() {
    this.observer = new MutationObserver(() => {
      this.setContent();
    });
    this.observer.observe(this.template.host, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  innerHTMLSetCallback() {}

  renderedCallback() {
    if (!this.didSetContent) {
      this.didSetContent = true;
      this.setContent();
    }
  }

  transformHTML(html: string): string {
    return html;
  }

  private setContent() {
    const element = this.contentElement;
    const transformedHTML = this.transformHTML(this.template.host.innerHTML);
    if (element.innerHTML !== transformedHTML) {
      element.innerHTML = transformedHTML;
      this.innerHTMLSetCallback();
    }
  }
}
